"use client";

import { useAtomValue } from "jotai";
import { useLocale } from "next-intl";
import React, { type ReactElement } from "react";
import {
  FeatureCard,
  FeatureCardContent,
  FeatureCardDescription,
} from "@/components";
import { featuredTagAtom } from "@/store/home";

function HomeFeaturedTag(): ReactElement | null {
  const locale = useLocale();
  const featuredTag = useAtomValue(featuredTagAtom);

  if (!featuredTag) return null;

  return (
    <FeatureCard className="rounded-2xl bg-background/80">
      <FeatureCardContent className="p-4 text-center lg:text-left">
        <FeatureCardDescription className="truncate text-wrap min-h-0 lg:max-w-md">
          {featuredTag.description[locale]}
        </FeatureCardDescription>
      </FeatureCardContent>
    </FeatureCard>
  );
}

export { HomeFeaturedTag };
